import { getHttpErrorStatus } from './get-http-error-status';

const INVALID_LINK_STATUSES = new Set([400, 404, 410]);

export function isInvalidLinkError(error: unknown): boolean {
  const status = getHttpErrorStatus(error);
  return status !== null && INVALID_LINK_STATUSES.has(status);
}
